import { NavLink } from "react-router-dom";
import classes from "../MngCommon.module.css";

function MngStatisticsNavigation(props) {
    return (
        <div className={classes.admin_sub_nav}>
            <nav>
                <ul className={classes.depth_1}>
                    <li className={classes.depth_1_link}>
                        <NavLink to="list">통계</NavLink>
                    </li>
                    {/* <li className={classes.depth_1_link}>
                        <NavLink to="https://analytics.google.com/analytics/">
                            Google Analytics
                        </NavLink>
                    </li> */}
                </ul>
            </nav>
        </div>
    );
}

export default MngStatisticsNavigation;
